import { useLocation } from "react-router-dom";
import { useEffect } from "react";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error("404 Error: User attempted to access non-existent route:", location.pathname);
  }, [location.pathname]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-muted">
      <div className="text-center">
        <h1 className="mb-4 text-7xl font-bold text-foreground">404</h1>
        <p className="mb-6 text-xl text-muted-foreground">Página não encontrada</p>
        <a href="/" className="glass-btn inline-flex items-center gap-2 px-6 py-3 text-sm font-medium">
          Voltar ao início
        </a>
      </div>
    </div>
  );
};

export default NotFound;
